import React from 'react';
import {
	Box,
	Table,
	TableBody,
	TableHead,
	TableRow,
	Typography,
} from '@mui/material';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../theme/color-palette';
import { Skeleton } from '@walmart-web/livingdesign-components';

const ShimmerAO = () => {
	const useStyles = makeStyles(() => ({
		header: {
			marginTop: '2%',
			marginLeft: '2%',
		},
		total: {
			marginTop: '5%',
		},
		learnMore: {
			marginLeft: '88%',
		},
		tableContainer: {
			width: '95% !important',
			marginLeft: '2%',
			marginTop: '5%',
			marginBottom: '3%',
		},
	}));

	const classes = useStyles();

	const rows = [1, 2, 3];

	return (
		<Box>
			<Box className={classes.header}>
				<Skeleton height="17.5px" width="129px" variant="rounded" />
			</Box>

			<Table className={classes.tableContainer}>
				<TableHead sx={{ '&:first-child td, &:first-child th': { border: 0 } }}>
					<TableRow
						sx={{
							backgroundColor: colors.WHITE_GREY,
						}}>
						<TableCell></TableCell>
						<TableCell>
							<Box>
								<Skeleton height="11px" width="104px" variant="rounded" />
							</Box>
							<Box className={classes.total}>
								<Skeleton height="8px" width="24px" variant="rounded" />
							</Box>
						</TableCell>
						<TableCell>
							<Box>
								<Skeleton height="11px" width="104px" variant="rounded" />
							</Box>
							<Box className={classes.total}>
								<Skeleton height="8px" width="24px" variant="rounded" />
							</Box>
						</TableCell>
						<TableCell>
							<Box>
								<Skeleton height="11px" width="104px" variant="rounded" />
							</Box>
							<Box className={classes.total}>
								<Skeleton height="8px" width="24px" variant="rounded" />
							</Box>
						</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{rows?.map((row) => (
						<TableRow
							key={row.name}
							sx={{
								[`& .${tableCellClasses.root}`]: {
									padding: '30px',
								},
							}}>
							<TableCell component="th" scope="row">
								<Typography>
									<Skeleton height="11px" width="151px" variant="rounded" />
								</Typography>
							</TableCell>
							<TableCell>
								<Typography>
									<Skeleton height="8px" width="24px" variant="rounded" />
								</Typography>
							</TableCell>
							<TableCell>
								<Typography>
									<Skeleton height="8px" width="24px" variant="rounded" />
								</Typography>
							</TableCell>
							<TableCell>
								<Typography>
									<Skeleton height="8px" width="24px" variant="rounded" />
								</Typography>
							</TableCell>
						</TableRow>
					))}
				</TableBody>
			</Table>
			<Box className={classes.learnMore}>
				<Skeleton height="10.5px" width="73px" variant="rounded" />
			</Box>
		</Box>
	);
};

export default ShimmerAO;
